import { useState } from 'react'
import { supabase } from '../lib/supabase'
import RichTextEditor from './RichTextEditor'

const BLOCK_TYPES = [
  { id: 'exercice_prescrit', label: 'Exercice prescrit' },
  { id: 'soin_pratique', label: 'Soin pratiqué' },
  { id: 'observation_clinique', label: 'Observation clinique' },
  { id: 'objectif_seance', label: 'Objectif de séance' },
  { id: 'progres_constate', label: 'Progrès constaté' },
  { id: 'point_vigilance', label: 'Point de vigilance' },
  { id: 'adaptation_protocole', label: 'Adaptation du protocole' },
  { id: 'materiel_utilise', label: 'Matériel utilisé' },
  { id: 'ressource_partagee', label: 'Ressource partagée' },
  { id: 'consigne_parents', label: 'Consigne aux parents' },
  { id: 'coordination_inter_pros', label: 'Coordination inter-pros' },
  { id: 'reaction_enfant', label: 'Réaction de l\'enfant' },
  { id: 'evaluation_test', label: 'Évaluation / test passé' },
  { id: 'photo_video', label: 'Photo / vidéo de séance' },
  { id: 'note_personnelle', label: 'Note personnelle' },
  { id: 'custom', label: '+ Créer un élément personnalisé' },
]

export default function SessionReportForm({ childId, appointmentId = null, existingReport = null, onClose, onSaved }) {  const [subject, setSubject] = useState(existingReport?.subject || '')
  const [content, setContent] = useState(existingReport?.content || '')
  const [blocks, setBlocks] = useState(existingReport?.report_blocks || [])
  const [saving, setSaving] = useState(false)
  const [showBlockPicker, setShowBlockPicker] = useState(false)

  const addBlock = (type) => {
    const typeInfo = BLOCK_TYPES.find(b => b.id === type)
    setBlocks(prev => [...prev, {
      tempId: Date.now(),
      block_type: type,
      title: type === 'custom' ? '' : typeInfo.label,
      content: '',
      document_file: null,
      document_url: null,
    }])
    setShowBlockPicker(false)
  }

  const updateBlock = (tempId, field, value) => {
    setBlocks(prev => prev.map(b => b.tempId === tempId ? { ...b, [field]: value } : b))
  }

  const removeBlock = (tempId) => {
    setBlocks(prev => prev.filter(b => b.tempId !== tempId))
  }

  const handleSave = async (status = 'draft') => {
    if (!subject.trim()) return alert('Merci de renseigner l\'objet du RDV.')
    if (!content || content === '<p></p>') return alert('Merci de renseigner le compte rendu.')
    setSaving(true)

    try {
      const { data: { user } } = await supabase.auth.getUser()

      // 1. Créer le rapport
let report, reportError
if (existingReport) {
  const { data, error } = await supabase
    .from('session_reports')
    .update({ subject, content, status })
    .eq('id', existingReport.id)
    .select()
    .single()
  report = data
  reportError = error
} else {
  const { data, error } = await supabase
    .from('session_reports')
    .insert({
      professional_id: user.id,
      child_id: childId,
      appointment_id: appointmentId,
      subject,
      content,
      status,
    })
    .select()
    .single()
  report = data
  reportError = error
}

      if (reportError) throw reportError

      // 2. Uploader les documents et insérer les blocs
      for (let i = 0; i < blocks.length; i++) {
        const block = blocks[i]
        let document_url = null

        if (block.document_file) {
          const ext = block.document_file.name.split('.').pop()
          const path = `reports/${report.id}/block_${i}.${ext}`
          const { error: uploadError } = await supabase.storage
            .from('documents')
            .upload(path, block.document_file)
          if (!uploadError) {
            const { data: urlData } = supabase.storage.from('documents').getPublicUrl(path)
            document_url = urlData.publicUrl
          }
        }

        await supabase.from('report_blocks').insert({
          report_id: report.id,
          block_type: block.block_type,
          title: block.title,
          content: block.content,
          document_url,
          position: i,
        })
      }

      onSaved && onSaved(report)
      onClose && onClose()
    } catch (err) {
      console.error(err)
      alert('Erreur lors de l\'enregistrement.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#fff', borderRadius: '16px', width: '100%', maxWidth: '720px',
        maxHeight: '90vh', overflow: 'auto', padding: '32px', position: 'relative'
      }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#1e293b' }}>
            📋 Nouveau compte rendu
          </h2>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#94a3b8'
          }}>×</button>
        </div>

        {/* Objet du RDV */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>
            Objet du RDV *
          </label>
          <input
            type="text"
            value={subject}
            onChange={e => setSubject(e.target.value)}
            placeholder="Ex : Séance de rééducation motrice"
            style={{
              width: '100%', padding: '10px 14px', borderRadius: '8px',
              border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box'
            }}
          />
        </div>

        {/* Compte rendu général */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>
            Compte rendu général *
          </label>
          <RichTextEditor
            value={content}
            onChange={setContent}
            placeholder="Décrivez le déroulement de la séance..."
          />
        </div>

        {/* Blocs additionnels */}
        {blocks.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '12px', color: '#374151' }}>
              Éléments additionnels
            </label>
            {blocks.map(block => (
              <BlockEditor
                key={block.tempId}
                block={block}
                onUpdate={(field, value) => updateBlock(block.tempId, field, value)}
                onRemove={() => removeBlock(block.tempId)}
              />
            ))}
          </div>
        )}

        {/* Ajouter un bloc */}
        {showBlockPicker ? (
          <div style={{
            border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', marginBottom: '20px'
          }}>
            <p style={{ margin: '0 0 12px', fontWeight: '600', color: '#374151' }}>Choisir un élément :</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {BLOCK_TYPES.map(type => (
                <button
                  key={type.id}
                  onClick={() => addBlock(type.id)}
                  style={{
                    padding: '6px 14px', borderRadius: '20px', border: '1px solid #667eea',
                    backgroundColor: '#f0f0ff', color: '#667eea', cursor: 'pointer', fontSize: '13px'
                  }}
                >
                  {type.label}
                </button>
              ))}
            </div>
            <button onClick={() => setShowBlockPicker(false)} style={{
              marginTop: '12px', background: 'none', border: 'none', color: '#94a3b8',
              cursor: 'pointer', fontSize: '13px'
            }}>Annuler</button>
          </div>
        ) : (
          <button
            onClick={() => setShowBlockPicker(true)}
            style={{
              width: '100%', padding: '12px', borderRadius: '8px',
              border: '2px dashed #cbd5e1', backgroundColor: 'transparent',
              color: '#667eea', cursor: 'pointer', fontSize: '14px', fontWeight: '600', marginBottom: '24px'
            }}
          >
            + Ajouter un élément
          </button>
        )}

        {/* Actions */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{
            padding: '10px 20px', borderRadius: '8px', border: '1px solid #e2e8f0',
            backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: '14px'
          }}>
            Annuler
          </button>
          <button onClick={() => handleSave('draft')} disabled={saving} style={{
            padding: '10px 20px', borderRadius: '8px', border: '1px solid #667eea',
            backgroundColor: '#fff', color: '#667eea', cursor: 'pointer', fontSize: '14px'
          }}>
            Enregistrer brouillon
          </button>
          <button onClick={() => handleSave('pending_parent')} disabled={saving} style={{
            padding: '10px 20px', borderRadius: '8px', border: 'none',
            backgroundColor: '#667eea', color: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: '600'
          }}>
            {saving ? 'Enregistrement...' : 'Envoyer pour partage →'}
          </button>
        </div>
      </div>
    </div>
  )
}

function BlockEditor({ block, onUpdate, onRemove }) {
  return (
    <div style={{
      border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', marginBottom: '12px',
      backgroundColor: '#fafafa'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        {block.block_type === 'custom' ? (
          <input
            type="text"
            value={block.title}
            onChange={e => onUpdate('title', e.target.value)}
            placeholder="Titre de l'élément personnalisé"
            style={{
              flex: 1, padding: '6px 10px', borderRadius: '6px',
              border: '1px solid #e2e8f0', fontSize: '14px', fontWeight: '600', marginRight: '8px'
            }}
          />
        ) : (
          <span style={{ fontWeight: '600', color: '#374151', fontSize: '14px' }}>
            {block.title}
          </span>
        )}
        <button onClick={onRemove} style={{
          background: 'none', border: 'none', color: '#f87171', cursor: 'pointer', fontSize: '18px'
        }}>×</button>
      </div>

      <textarea
        value={block.content}
        onChange={e => onUpdate('content', e.target.value)}
        placeholder="Description..."
        rows={3}
        style={{
          width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0',
          fontSize: '13px', resize: 'vertical', boxSizing: 'border-box', marginBottom: '8px'
        }}
      />

      <div>
        <label style={{ fontSize: '12px', color: '#94a3b8', display: 'block', marginBottom: '4px' }}>
          Document joint (optionnel)
        </label>
        {block.document_url ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '12px', color: '#667eea' }}>📎 Fichier joint</span>
            <button onClick={() => onUpdate('document_url', null)} style={{
              background: 'none', border: 'none', color: '#f87171', cursor: 'pointer', fontSize: '12px'
            }}>Supprimer</button>
          </div>
        ) : (
          <input
            type="file"
            onChange={e => onUpdate('document_file', e.target.files[0])}
            style={{ fontSize: '12px' }}
          />
        )}
      </div>
    </div>
  )
}